/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {CachedItem} from '@ion/dls/src/types/types';
import {updateItemStored} from '@/store/actions/groups-filter';

/**
 * React Hook to provide util functions for update asset / device in redux store 
 * for caching.
 * 
 *  ```typescript
 * 
 *   import {useUpdateItemStored} from '../../hooks/';
 * 
 *   const onUpdateItemStored = useUpdateItemStored();
 * 
 *  ```
 */
export const useUpdateItemStored = () => {
  const dispatch = useDispatch();

  const onUpdateItemStored = useCallback((itemInfo: CachedItem) => {
    dispatch(updateItemStored(itemInfo));
  }, []);

  return onUpdateItemStored;
};
